<template>
  <div class="login">
    <div v-if="false" class="rays"></div>
    <div class="background">
      <div>
        <b-button to="/" class="btn-back" variant="link">
          <img
            src="@/assets/Login/voltar.png"
            alt="Botão com seta para esquerda indicando para voltar a página anterior"
          />
          Voltar para o site
        </b-button>
      </div>

      <div>
        <b-container>
          <b-row>
            <b-card>
              <b-col
                style="padding: 50px"
                lg="12"
                class="pb-4 d-flex justify-content-center"
              >
                <img
                  class="logo"
                  src="@/assets/Login/COMP WEEK.svg"
                  alt="Imagem logo da Comp Week, sendo as letras da mesma em caixa alta"
                />
              </b-col>
              <b-alert v-model="showAlert" show variant="light" dismissible>
                <b-icon-exclamation-triangle-fill
                  variant="danger"
                  v-if="alertType == 'error'"
                />
                <b-icon v-else icon="check" variant="success" />
                {{ textAlert }}
              </b-alert>
              <div>
                <b-form @submit="onSignin">
                  <b-form-group>
                    <label class="label">Email</label>
                    <b-form-input
                      type="email"
                      required
                      v-model="$v.form.email.$model"
                      class="form-control"
                      placeholder
                      :state="validateState('email')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <label class="label">Senha</label>
                    <b-form-input
                      type="password"
                      required
                      v-model="$v.form.password.$model"
                      :state="validateState('password')"
                      class="form-control"
                      placeholder
                    ></b-form-input>
                    <b-button
                      href="/esqueci-senha"
                      class="btn-forgot-password"
                      variant="link"
                      >Esqueci minha senha</b-button
                    >
                  </b-form-group>
                  <Login
                    :disabled="$v.$invalid"
                    :showSpinner="showSpinner"
                    texto="ENTRAR"
                  />
                </b-form>
              </div>
              <!-- <b-col class="d-flex justify-content-center pb-3">
                <b-button
                  to="cadastre-se"
                  class="btn-hover register"
                  type="submit"
                  >Cadastrar</b-button
                >
              </b-col> -->
            </b-card>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../../components/Button-fill";
import { Signin } from "@/services/api/Auth";
import { SetCookie } from "@/utils/CookieUtil";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import fieldValidation from "@/utils/FieldValidation";
import jwt_decode from "jwt-decode";

export default {
  mixins: [validationMixin, fieldValidation],
  components: {
    Login,
  },
  data() {
    return {
      showSpinner: false,
      textAlert: "",
      showAlert: false,
      alertType: "",
      form: {
        email: "",
        password: "",
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  created() {
    if (this.$route.query.verified) {
      this.showAlert = true;
      this.alertType = "info";
      this.textAlert = "Sua conta foi ativada. Faça o login para continuar";
    } else if (this.$route.query.senhaAlterada) {
      this.showAlert = true;
      this.alertType = "info";
      this.textAlert =
        "Senha alterada com sucesso. Faça o login para continuar";
    }
  },
  methods: {
    onSignin(evt) {
      evt.preventDefault();
      this.showSpinner = true;

      Signin(this.form.email, this.form.password)
        .then((res) => {
          SetCookie("token", res.data.token, {
            expires: Number.parseInt(res.data.tokenExpiration),
          });

          const decoded = jwt_decode(res.data.token);

          if (decoded.role == "admin") {
            this.showSpinner = false;
            this.$router.push("/admin/palestras");
          } else {
            this.showSpinner = false;
            this.$router.push("/palestras");
          }
        })
        .catch((error) => {
          console.error("erro ao fazer login", error.response);
          this.showAlert = true;
          this.textAlert = error.response.data.error;
          this.alertType = "error";
          this.showSpinner = false;
        });
    },
  },
};
</script>

<style>
html {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
.rays {
  position: absolute;
  background-size: 200% 100%;
  background-image: linear-gradient(
    247.22deg,
    rgba(43, 25, 93, 0.9) 0%,
    rgba(117, 40, 194, 0.9) 100%
  );
  mask: url("~@/assets/Home/rays.svg");
  -webkit-mask: url("~@/assets/Home/rays.svg");
  mask-size: 300%;
  mask-repeat: no-repeat;
  animation: 90s linear infinite raysMoving;
  transform: translateX(-10%) rotate(155deg);
  width: 120%;
  height: 100%;
}

@keyframes raysMoving {
  0% {
    mask-position: 0%;
  }
  100% {
    mask-position: 100%;
  }
}
.alert-light {
  box-shadow: 6px #00000029;
}
.login {
  background-color: #fcfcfc;
  font-family: Roboto;
  height: 100vh;
  margin: 0 auto;
}

.label {
  color: #000000;
  font-family: Roboto;
}

.background {
  background-image: url("~@/assets/Login/LinhaRoxa.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top;
}
.form-control {
  border-radius: 0rem;
  border: 1px solid #5b5b5b;
}

.btn-back {
  text-decoration: none;
  font-size: 17px;
  font-family: Roboto;
  color: #000000 !important;
  margin-left: 5%;
  padding-top: 50px;
  display: inline-block;
}
.container {
  padding: 25px;
}
.card {
  border: 0px;
  background-color: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin: 0 auto;
  margin-bottom: 20px;
  width: 24rem;
}

.logo {
  width: 225px;
  height: 120px;
}

.btn-forgot-password {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  color: #777777 !important;
  margin-left: -12px;
}

@media screen and (max-width: 768px) {
  .rays {
    display: none;
  }
}
@media screen and (max-width: 260px) {
  .logo {
    width: 130px;
    height: 57px;
  }
  .btn-register {
    color: #ffffff;
  }
}

@media screen and (min-width: 375px) and (max-width: 540px) {
  .card {
    margin-top: 4rem;
  }
}

@media screen and (width: 375px) and (height: 667px) {
  .card {
    margin-top: 2rem;
  }
}

@media screen and (width: 768px) {
  .card {
    margin-top: 11rem;
  }
}

@media screen and (width: 1024px) {
  .card {
    margin-top: 17rem;
  }
}
</style>
